import { useEffect } from 'react';
import { useDataProvider } from '../DataProviderContext';

/**
 * Identify and cleanup inconsistencies in table state.
 *
 * For example, a table is filtered on a column which no longer exists.
 *
 * @constructor
 */
export const StateCleanup = () => {
  const { table } = useDataProvider();
  const tableState = table?.state;

  useEffect(() => {
    if (!tableState || !table) {
      return;
    }

    const { columnFilters = [], sorting = [] } = tableState;

    // Filter on non-existing column
    if (columnFilters.some((filter) => !table.getColumn(filter.id))) {
      table.resetColumnFilters();
    }

    // Sort on non-existing column
    if (sorting.some((sort) => !table.getColumn(sort.id))) {
      table.resetSorting();
    }
  }, [tableState, table]);

  return null;
};
